import React from 'react'

const ProgressBar = ({
  totalSteps,
  currentStep,
}) => {
  return (
    <div className="w-full bg-gray-200 h-2 rounded-full">
      <div
        className="bg-rose-500 h-2 rounded-full transition-all duration-300"
        style={{ width: `${(currentStep / totalSteps) * 100}%` }}
      ></div>
    </div>
  );
}

export default ProgressBar